<div>
  <div *ngIf="notInLogonPage && !isPageNotFound">
    <app-ri-header>header</app-ri-header>
  </div>
  <div id="content" class="page-content">
    <router-outlet></router-outlet>
  </div>
</div> 
<app-copyright *ngIf="!isPageNotFound"></app-copyright>
